import type { GlobalFilterOverrides, OutcomeToDisplay, Filter } from '../types';
import type { OutcomeParameterName } from '../../../types';
import { getActiveValueWithOverride } from '../utils/getActiveValueWithOverride';

/*
 * Фильтрует исходы по общим для всех рынков параметрам типа ROUND, PARITICIPANT etc
 */
export function filterDefault(
    outcomes: OutcomeToDisplay[], 
    filters: Map<OutcomeParameterName, Filter>, 
    globalFilterOverrides: GlobalFilterOverrides,
): OutcomeToDisplay[] {
    return outcomes.filter((outcome) => {
        for (const filter of filters.values()) {
            // пропускаем фильтры со значением линии форы/тотала — фильтруются в filterHandicap / filterTotal
            if(filter.kind === 'NUMERIC_PARAM_VALUE') {
                continue;
            }

            const activeValue = getActiveValueWithOverride(filter, globalFilterOverrides);

            if (!activeValue) {
                continue;
            }

            if (!outcome.paramsMap.get(filter.name)?.has(activeValue)) {
                return false;
            }
        }

        return true;
    });
}
